import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';

export const TOGGLE = trigger('toggle', [
  state(
    'off',
    style({
      left: '2px',
      background: '#505563',
    })
  ),

  state(
    'on',
    style({
      left: '20px',
      background: '#22b463',
    })
  ),
  transition('on => off', [animate('0.25s')]),
  transition('off => on', [animate('0.25s')]),
]);
